/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Pull_Business_ToolsInputs */



/**
* | output |
* | --- |
* | "Pull data from business tools" |
*
* @param {Onboarding_Usage_Pull_Business_ToolsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_pull_business_tools = /** @type {((inputs?: Onboarding_Usage_Pull_Business_ToolsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Pull_Business_ToolsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Daten aus Business-Tools abrufen")
	return /** @type {LocalizedString} */ ("Pull data from business tools")
});